module.exports = __webpack_public_path__ + "static/media/project-icon-blog.30ffb433.png";